<div class="toast-container">
  <img src="assets/images/toaster-icon.svg" class="mr-10" alt="">
  <div class="toast-message">{{message}}</div>
  <button (click)="onActionClick(text)" class="toast-action" *ngFor="let text of buttonText">{{text}}</button>
  <button (click)="onCloseClick()" class="toast-close"><img src="assets/images/camcle-24-white.svg" /></button>
</div>